<template>
  <div class="content-top-padding initiatives globalVisibility missYouToo" v-cloak>
    <InitNav />
    <GvNav redBg="second-nav-bg" secondNav="second-nav" />

    <div class="container-fluid banner p-0 mb-5">
      <img
        alt=""
        src="@/assets/initiatives/globalVisibility/banner02_global-visibility-e.jpg"
        class="d-none d-md-block"
      />
      <img
        alt=""
        src="@/assets/initiatives/globalVisibility/m_banner02_gobal visibility-e.jpg"
        class="d-block d-md-none"
      />
    </div>

    <div class="container">
      <CustomBreadcrumb gv :lastTag="$t('title.gvMissU2')" />

      <div class="row routing d-flex justify-content-between align-items-center mb-5">
        <div class="col main-theme">
          <router-link :to="{ name: 'HolidayAtHome' }" class="d-flex flex-row align-items-center">
            <div class="">
              <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
            </div>
            <div>{{ $t("title.holiday") }}</div>
          </router-link>
        </div>
        <div class="col main-theme">
          <router-link
            :to="{ name: 'GearingUpTheTrade-Uncease' }"
            class="d-flex justify-content-end text-right align-items-center"
          >
            {{ $t("title.gearing") }}
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>

      <GvIntro />
      <GvPageSelector />

      <div class="row page-header mb-5 mt-3">
        <div class="col-12 main-theme text-center mb-4">
          <h3 id="GvPageHeading" v-if="$i18n.locale == 'zh'">
            #MissYouToo：讓香港與世界保持連繫
          </h3>
          <h3 id="GvPageHeading" v-else>
            #MissYouToo: Keeping Hong Kong Connected with the World
          </h3>
        </div>
        <div class="col-12 text-theme" v-if="$i18n.locale == 'zh'">
          旅發局於香港及多個客源市場，尤其是短途市場，推出#MissYouToo主題推廣活動，聯繫香港與全球消費者。旅發局在#MissYouToo活動中，先邀請本港各大業界夥伴、名人及各界人物，借助他們的影響力重新喚醒公眾對香港的熱愛，再配合一系列富創意的營銷及推廣攻勢，傳遞鼓舞人心、發揮好客精神的訊息，務求在旅客未能外遊期間，香港能繼續成為當地消費者心目中的首選旅遊目的地。
        </div>
        <div class="col-12 text-theme" v-else>
          Starting from Hong Kong, the HKTB rolled out the “#MissYouToo” thematic promotions in
          various source markets, especially in short-haul ones, to maintain the connection between
          Hong Kong and consumers worldwide, thus rekindling their love for Hong Kong. The HKTB
          first engaged a wide selection of trade partners, local celebrities and various
          personalities in different sectors in Hong Kong under the “#MissYouToo” campaign to
          leverage on their influence to rekindle the love of the public for Hong Kong. Together
          with a series of creative marketing campaigns and promotions, “#MissYouToo” spread the
          same encouraging and welcoming messages to keep Hong Kong a top-of-mind destination among
          consumers in these markets during travel restrictions.
        </div>
      </div>

      <div class="row left-carou Miss-You mb-5">
        <CoolLightBox
          :items="lightbox.stRowZh"
          :index="index1"
          @close="index1 = null"
          :effect="'fade'"
          v-if="$i18n.locale == 'zh'"
        >
        </CoolLightBox>
        <CoolLightBox
          :items="lightbox.stRow"
          :index="index1"
          @close="index1 = null"
          :effect="'fade'"
          v-else
        >
        </CoolLightBox>
        <div class="col-lg-6 mb-5 mb-lg-0">
          <b-carousel id="carousel-1" class="carou-slide">
            <b-carousel-slide>
              <template #img>
                <img
                  @click="index1 = 0"
                  class="d-block img-fluid w-100"
                  src="@/assets/initiatives/globalVisibility/4-2-1-1-1-preview-MissYouTooVideo-e.jpg"
                  alt="image slot"
                />
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
        <div class="col-lg-6">
          <div class="main-theme mb-4">
            <h4>{{ $t("gv.mu2.mu2.heading") }}</h4>
          </div>
          <div class="text-theme" v-if="$i18n.locale == 'zh'">
            2020年4月起，當各地紛紛實施旅遊限制時，旅發局即推出「#MissYouToo」主題推廣活動，借助社會上不同持份者的影響力，傳達「#MissYouToo」的訊息。參與活動人士包括多位名廚、歌手、網紅、居港外籍人士、食評家，以及來自航空業、景點和酒店業等旅遊相關行業的業界夥伴，向遊客分享最想念的香港事物和美好回憶。<br /><br />有關短片上載至旅發局的社交平台，並可於多個渠道，包括專為外籍人士提供本地資訊的媒體《Localiiz》觀看，從而向海外旅客傳遞香港歡迎旅客重臨，並一如以往為好客之都的正面訊息。
          </div>
          <div class="text-theme" v-else>
            First launched in April 2020 when travel restrictions started to come into place, the
            HKTB leveraged on various stakeholders’ influence in the society to spread the message
            of “#MissYouToo”. Celebrity chefs, singers, influencers, expatriates, food writers as
            well as trade partners from tourism-related sectors, including the aviation, attractions
            and hospitality sectors shared the things they missed most in Hong Kong and their fond
            memories with visitors.
            <br /><br />
            The videos were available on the HKTB’s social media platforms and media channels
            including expat media <i>Localiiz</i> to broadcast to audiences outside Hong Kong a
            positive and embracing message that our city loves to welcome back visitors and remains
            a hospitable travel destination.
          </div>
        </div>
      </div>

      <div class="row right-carou Southeast mb-5">
        <CoolLightBox
          :items="lightbox.ndRowZh"
          :index="index2"
          @close="index2 = null"
          :effect="'fade'"
          v-if="$i18n.locale == 'zh'"
        >
        </CoolLightBox>
        <CoolLightBox
          :items="lightbox.ndRow"
          :index="index2"
          @close="index2 = null"
          :effect="'fade'"
          v-else
        >
        </CoolLightBox>
        <div class="order-1 order-lg-0 col-lg-6">
          <div class="main-theme mb-4">
            <h4>{{ $t("gv.mu2.southeast.heading") }}</h4>
          </div>
          <div class="text-theme" v-if="$i18n.locale == 'zh'">
            旅發局於2020年7月推出「100 Reasons to Miss Hong
            Kong」主題推廣活動，在新加坡、印尼、馬來西亞、泰國、菲律賓、越南等短途市場不斷推廣香港美食、維港景色和街道景致的獨特魅力，宣揚香港獨有的本地文化。
            <br /><br />
            旅發局特意為當地名人、網絡紅人與媒體夥伴設計多款小食包、烹飪套裝及贈禮，讓他們先在家體驗香港的美食和文化，然後將自己有趣的體驗，發布於社交媒體，並與他們的朋友及追隨者分享。此外，旅發局亦於當地市場透過一系列的虛擬活動，如密室逃脫遊戲、烹飪班和遠足導賞，以及其他點播內容，如粵語學習短片和茶餐廳食譜等，讓喜歡香港的東南亞旅客即使無法來港，也可繼續感受香港的魅力。
          </div>
          <div class="text-theme" v-else>
            In short-haul markets including Singapore, Indonesia, Malaysia, Thailand, Philippines
            and Vietnam, the thematic promotion “100 Reasons to Miss Hong Kong” came into scene in
            July 2020 to engage consumers in the market through unceasing reminder of Hong Kong’s
            unique appeal in food, harbourview and streetscape, and its local culture that cannot be
            found elsewhere.
            <br /><br />
            The HKTB specially curated various snack packs, cooking kits and drop kits to local
            celebrities, online personalities and media partner to offer them an at-home experience
            of Hong Kong’s food and cultural offerings. The influencers then reposted their
            experience to share the joy with their followers. Together with a series of virtual
            real-time events such as escape room game, cook-along classes and hiking tours, and
            other on-demand contents such as Cantonese learning videos and Cha Chaan Teng recipes,
            Hong Kong lovers in the SE Asian markets can continue to get a taste of Hong Kong even
            though they cannot visit.
          </div>
        </div>
        <div class="order-0 order-lg-1 mb-5 mb-lg-0 col-lg-6">
          <b-carousel id="carousel-2" class="carou-slide d-none d-md-block" controls>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex align-items-center second-slide">
                  <img
                    @click="index2 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-2-2-preview-100ReasonsKV2-e.jpg"
                    alt="image slot"
                    style=""
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex align-items-center third-slide">
                  <img
                    @click="index2 = 1"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-2-3-preview-Cantonese-Video-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex align-items-center">
                  <img
                    @click="index2 = 2"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-2-4-preview-ManilaWWO-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex align-items-center">
                  <img
                    @click="index2 = 3"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-2-5-preview-SnackPack-CelineTan-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
          <b-carousel id="carousel-2" class="carou-slide d-block d-md-none" controls>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="1" class="d-flex align-items-center second-slide">
                  <img
                    @click="index2 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-2-2-preview-100ReasonsKV2-e.jpg"
                    alt="image slot"
                    style=""
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="1" class="d-flex align-items-center third-slide">
                  <img
                    @click="index2 = 1"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-2-3-preview-Cantonese-Video-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="1" class="d-flex align-items-center">
                  <img
                    @click="index2 = 2"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-2-4-preview-ManilaWWO-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="1" class="d-flex align-items-center">
                  <img
                    @click="index2 = 3"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-2-5-preview-SnackPack-CelineTan-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>

      <div class="row left-carou Singapore mb-5">
        <CoolLightBox
          :items="lightbox.rdRow"
          :index="index3"
          @close="index3 = null"
          :effect="'fade'"
        >
        </CoolLightBox>
        <div class="col-lg-6 mb-5 mb-lg-0">
          <b-carousel id="carousel-3" class="carou-slide d-none d-md-block" controls>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="index3 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-3-2-preview-jenny-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="index3 = 1"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-3-1-preview-grabpromo-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
          <b-carousel id="carousel-3" class="carou-slide d-block d-md-none" controls>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="1" class="d-flex align-items-center">
                  <img
                    @click="index3 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-3-2-preview-jenny-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="1" class="d-flex align-items-center">
                  <img
                    @click="index3 = 1"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-3-1-preview-grabpromo-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
        <div class="col-lg-6">
          <div class="main-theme mb-4">
            <h4>{{ $t("gv.mu2.singapore.heading") }}</h4>
          </div>
          <div class="text-theme" v-if="$i18n.locale == 'zh'">
            旅發局與馬來西亞大型外賣平台Grab等知名品牌合作，讓消費者居家抗疫時亦能品嘗香港美食。雙方合作推出「Grab
            Food
            Passport」推廣活動，提供多種消費折扣優惠，包括適用於當地售賣茶餐廳食品、點心和粵式燒味等香港美食的食肆消費優惠。
            <br /><br />
            在「#MissYouToo」推廣活動期間，人氣手信店珍妮曲奇新加坡分店與旅發局攜手合作推廣，反應十分熱烈。新加坡消費者在預售階段已踴躍訂購，一嚐香港精心製作的曲奇。此外，是次限時推廣活動亦向當地消費者介紹其他設有海外分店的香港品牌，包括恆香、歡樂冰室、甘牌燒鵝、妹記生滾粥品等。
          </div>
          <div class="text-theme" v-else>
            Partnering with household brands such as Grab, Malaysia’s major delivery platform, the
            HKTB made Hong Kong’s foodie experience reachable to home-bound consumers. The joint
            “Grab Food Passport” promotion offered discounts on local eateries that offer Hong Kong
            cuisines such as Cha Chaan Teng food, dimsum and Cantonese roasts.
            <br /><br />
            Popular souvenir shop Jenny Bakery’s Singaporean branch also made record-breaking sales
            during a joint promotion with the HKTB during the “#MissYouToo” promotions and Singapore
            consumers had to made bookings to get their favourite Hong Kong crafted cookies. Other
            Hong Kong Brands with overseas branches, including Hang Heung, Joyluck Teahouse, Kam’s
            Roast, Mui Kee Congee, were also introduced to local consumers in a time-limited
            promotion.
          </div>
        </div>
      </div>

      <div class="row right-carou Japan mb-5">
        <CoolLightBox
          :items="lightbox.fourthRowZh"
          :index="index4"
          @close="index4 = null"
          :effect="'fade'"
          v-if="$i18n.locale == 'zh'"
        >
        </CoolLightBox>
        <CoolLightBox
          :items="lightbox.fourthRow"
          :index="index4"
          @close="index4 = null"
          :effect="'fade'"
          v-else
        >
        </CoolLightBox>
        <div class="order-1 order-lg-0 col-lg-6">
          <div class="main-theme mb-4">
            <h4>{{ $t("gv.mu2.japan.heading") }}</h4>
          </div>
          <div class="text-theme" v-if="$i18n.locale == 'zh'">
            日本「Taste Hong Kong
            Now」線上線下推廣活動與當地4大地區、24家精選餐廳合作，不但為當地人提供超值的香港美食體驗，消費者亦可在社交媒體分享美食之旅的精美相片，便有機會贏得機票和其他獎品。參與活動的餐廳種類繁多，由街頭小吃店，如雞蛋仔攤檔Bubble
            Shop
            Tamagochan，至米芝蓮名店如添好運及頂級食府喜記海鮮飯店等。多位電視名人及知名食評家亦發表了美食相片，鼓勵消費者在旅遊限制放寬前，到訪日本當地的香港食肆。
          </div>
          <div class="text-theme" v-else>
            With the participation of 24 selected restaurants in 4 major regions in Japan, the
            “Taste Hong Kong Now” online-offline promotion offered Japanese not only value-added
            Hong Kong gourmet experience but also a chance to win air tickets and other prizes by
            sharing luscious photos of their culinary journey on social media. Participating
            restaurants ranged from street snacks such as egg waffle stall Bubble Shop Tamagochan to
            Michelin names Tim Ho Wan and top-tier restaurants Hei Gei Seafood Restaurant. TV icons
            and famous food writers also contributed their foodie photos to encourage consumers to
            visit Hong Kong restaurants in Japan before travel resumption.
          </div>
        </div>
        <div class="order-0 order-lg-1 mb-5 mb-lg-0 col-lg-6 align-self-start">
          <b-carousel id="carousel-4" class="carou-slide d-none d-md-block" controls>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center first-slide">
                  <img
                    @click="index4 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-4-2-previewTasteHKNow-Video-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center second-slide">
                  <img
                    @click="index4 = 1"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-4-1-preview-TasteHKNow-e.jpg"
                    alt="image slot"
                    style=""
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center third-slide">
                  <img
                    @click="index4 = 2"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-4-3-preview-instagramcampaign-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
          <b-carousel id="carousel-4" class="carou-slide d-block d-md-none" controls>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="1" class="d-flex align-items-center first-slide">
                  <img
                    @click="index4 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-4-2-previewTasteHKNow-Video-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="1" class="d-flex align-items-center second-slide">
                  <img
                    @click="index4 = 1"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-4-1-preview-TasteHKNow-e.jpg"
                    alt="image slot"
                    style=""
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="1" class="d-flex align-items-center third-slide">
                  <img
                    @click="index4 = 2"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-4-3-preview-instagramcampaign-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>

      <div class="row left-carou Korea mb-5">
        <CoolLightBox
          :items="lightbox.fifthRow"
          :index="index5"
          @close="index5 = null"
          :effect="'fade'"
        >
        </CoolLightBox>
        <div class="col-lg-6 mb-5 mb-lg-0">
          <b-carousel id="carousel-5" class="carou-slide d-none d-md-block" controls>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="index5 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-1-preview-colouring-page-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="index5 = 1"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-2-preview-play_nomore-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="index5 = 2"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-3-preview-happysaea-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="index5 = 3"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-6-preview-Korean-colourbook-3-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="index5 = 4"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-5-preview-Korean-colourbook-2-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="index5 = 5"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-4-preview-Korean-colourbook-1-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
          <b-carousel id="carousel-5" class="carou-slide d-block d-md-none" controls>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="3:4" class="d-flex align-items-center">
                  <img
                    @click="index5 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-1-preview-colouring-page-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="3:4" class="d-flex align-items-center">
                  <img
                    @click="index5 = 1"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-2-preview-play_nomore-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="3:4" class="d-flex align-items-center">
                  <img
                    @click="index5 = 2"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-3-preview-happysaea-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="3:4" class="d-flex align-items-center">
                  <img
                    @click="index5 = 3"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-6-preview-Korean-colourbook-3-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="3:4" class="d-flex align-items-center">
                  <img
                    @click="index5 = 4"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-5-preview-Korean-colourbook-2-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="3:4" class="d-flex align-items-center">
                  <img
                    @click="index5 = 5"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/4-2-1-5-4-preview-Korean-colourbook-1-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
        <div class="col-lg-6">
          <div class="main-theme mb-4">
            <h4>{{ $t("gv.mu2.southKorea.heading") }}</h4>
          </div>
          <div class="text-theme" v-if="$i18n.locale == 'zh'">
            在南韓，旅發局與當地插畫師合作，設計了一系列象徵香港的標誌圖案及地標，並輯錄成《Hello!
            Hong
            Kong》便攜填色本，以此作為禮物送給南韓的媒體和年輕網絡紅人。旅發局亦在日本推出名為「Paint
            Hong Kong Now」的類似活動。<br /><br />因應疫情下居家的新趨勢，《Hello! Hong
            Kong》填色本正可為旅客在旅遊限制實施期間中，提供既有趣又安全的方式探索香港。南韓和日本的公眾亦可於旅發局網站下載填色紙，以贏取填色本或精美手帕乙份。
          </div>
          <div class="text-theme" v-else>
            The HKTB curated a series of symbolic icons and landmarks of Hong Kong in collaboration
            with Korean illustrators and combined them into a portable Hello! Hong Kong colouring
            book as a gift to our correspondences and young opinion leaders in South Korea. A
            similar campaign, “Paint Hong Kong Now”, was also launched in Japan.
            <br /><br />
            Tapping into the new stay-home trend under COVID-19, the
            <i>Hello! Hong Kong</i> colouring book provides a fun and safe pastime to explore Hong
            Kong while travel remains restricted. The Korean and Japanese public could also download
            the colouring pages on the HKTB’s website to win a copy of the colouring book or a
            specially designed handkerchief.
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid foot-note mb-5">
      <div class="container py-3">
        <div class="row">
          <div class="col">
            <div class="title my-3" v-if="$i18n.locale == 'zh'">
              <h3>#MissYouToo：重點數字</h3>
            </div>
            <div class="title my-3" v-else>
              <h3>“#MissYouToo” in numbers</h3>
            </div>
            <div class="dot-points text-theme" v-if="$i18n.locale == 'zh'">
              <ul>
                <li>#MissYouToo本地名人短片：12段YouTube短片，總瀏覽量達60萬次</li>
                <li>
                  「100 Reasons to Miss Hong Kong」：260位網紅在社交平台分享體驗，覆蓋9,700萬觀眾
                </li>
                <li>
                  「100 Reasons to Miss Hong Kong」：220多份媒體報導，全球宣傳效益超過610萬港元
                </li>
                <li>
                  新加坡「Grab Food Passport」品牌合作：兌換約3,000次
                </li>
                <li>
                  新加坡珍妮曲奇品牌合作：3天內售罄
                </li>
                <li>
                  日本「Taste Hong Kong Now」：24家餐廳參與，涵蓋日本4大地區
                </li>
                <li>
                  日本「Taste Hong Kong Now」：日本宣傳效益高達570萬港元
                </li>
                <li>
                  韓國「Paint Hong Kong Now」：社交平台比賽活動收集逾500份作品
                </li>
              </ul>
            </div>
            <div class="dot-points text-theme" v-else>
              <ul>
                <li>
                  “#MissYouToo” local personality videos: 12 videos on YouTube with 600,000 views
                </li>
                <li>
                  “100 Reasons to Miss Hong Kong”: 260 KOLs reaches 97 million on social platforms
                </li>
                <li>
                  “100 Reasons to Miss Hong Kong” worldwide publicity: more than 220 media clips
                  with over HK$6.1 million publicity value
                </li>
                <li>
                  “Grab Food Passport” Singapore brand partnership: about 3,000 redemptions
                </li>
                <li>
                  Jenny Bakery Singapore brand partnership: sold out in 3 days
                </li>
                <li>
                  “Taste Hong Kong Now” Japan trade partnership: 24 participating restaurants in 4
                  regions of Japan
                </li>
                <li>
                  “Taste Hong Kong Now” Japan publicity programme: HK$5.7 million publicity value
                </li>
                <li>
                  “Paint Hong Kong Now” South Korea social media giveaway: more than 500 entries
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <GvPageSelector />
    </div>
    <GvNav mainTheme="main-theme" secondNav="second-nav" mu2 />

    <div class="container">
      <div class="row routing d-flex justify-content-between align-items-center my-5">
        <div class="col main-theme">
          <router-link :to="{ name: 'HolidayAtHome' }" class="d-flex flex-row align-items-center">
            <div class="">
              <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
            </div>
            <div>{{ $t("title.holiday") }}</div>
          </router-link>
        </div>
        <div class="col main-theme">
          <router-link
            :to="{ name: 'GearingUpTheTrade-Uncease' }"
            class="d-flex justify-content-end text-right align-items-center"
          >
            {{ $t("title.gearing") }}
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>
    </div>
    <BackToTopBtn />
  </div>
</template>

<script>
import BackToTopBtn from "@/components/BackToTopBtn.vue";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import InitNav from "@/components/InitiativesNav.vue";
import GvIntro from "@/components/GlobalVisibility/GvIntro.vue";
import GvNav from "@/components/GlobalVisibility/GvNav.vue";
import CustomBreadcrumb from "@/components/CustomBreadcrumb.vue";
import GvPageSelector from "@/components/GlobalVisibility/GvPageSelector.vue";

export default {
  name: "GlobalVisibility-MissYouToo",
  components: {
    BackToTopBtn,
    CoolLightBox,
    GvIntro,
    GvNav,
    InitNav,
    CustomBreadcrumb,
    GvPageSelector,
  },
  metaInfo: {
    title: "Global Visibility",
    titleTemplate: "%s - HKTB Annual Report 2020/21",
  },
  data() {
    return {
      lightbox: {
        stRow: [
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286088348001",
            mediaType: "iframe",
          },
        ],
        stRowZh: [
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286088351001",
            mediaType: "iframe",
          },
        ],
        ndRow: [
          // "initiatives/global/4-2-1-2-1-100ReasonsKV-e.jpg",
          "initiatives/global/4-2-1-2-2-100ReasonsKV2-e.jpg",
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286089073001",
            mediaType: "iframe",
          },
          "initiatives/global/4-2-1-2-4-ManilaWWO-e.jpg",
          "initiatives/global/4-2-1-2-5-SnackPack-CelineTan-e.jpg",
        ],
        ndRowZh: [
          // "initiatives/global/4-2-1-2-1-100ReasonsKV-e.jpg",
          "initiatives/global/4-2-1-2-2-100ReasonsKV2-e.jpg",
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286088671001",
            mediaType: "iframe",
          },
          "initiatives/global/4-2-1-2-4-ManilaWWO-e.jpg",
          "initiatives/global/4-2-1-2-5-SnackPack-CelineTan-e.jpg",
        ],
        rdRow: [
          "initiatives/global/4-2-1-3-2-jenny-e.jpg",
          "initiatives/global/4-2-1-3-1-grabpromo-e.jpg",
        ],
        fourthRowZh: [
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286091015001",
            mediaType: "iframe",
          },
          "initiatives/global/4-2-1-4-1-TasteHKNow-e.jpg",
          "initiatives/global/4-2-1-4-3-instagramcampaign-e.jpg",
        ],
        fourthRow: [
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286091013001",
            mediaType: "iframe",
          },
          "initiatives/global/4-2-1-4-1-TasteHKNow-e.jpg",
          "initiatives/global/4-2-1-4-3-instagramcampaign-e.jpg",
        ],
        fifthRow: [
          "initiatives/global/4-2-1-5-1-colouring-page-e.jpg",
          "initiatives/global/4-2-1-5-2-play_nomore-e.jpg",
          "initiatives/global/4-2-1-5-3-happysaea-e.jpg",
          "initiatives/global/4-2-1-5-6-Korean-colourbook-3-e.jpg",
          "initiatives/global/4-2-1-5-5-Korean-colourbook-2-e.jpg",
          "initiatives/global/4-2-1-5-4-Korean-colourbook-1-e.jpg",
        ],
      },
      index1: null,
      index2: null,
      index3: null,
      index4: null,
      index5: null,
    };
  },
  mounted() {
    if (this.$i18n.locale == "zh") {
      let zh4 = document.querySelectorAll("h3, h4");
      for (let i = 0; i < zh4.length; i++) {
        zh4[i].style.fontWeight = "bold";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.missYouToo {
  #carousel-2 {
    text-align: -webkit-center;
    img {
      max-height: 249px;
    }
  }
  #carousel-3 {
    text-align: -webkit-center;
    img {
      max-height: 244px;
    }
  }
  #carousel-4 {
    text-align: -webkit-center;
    img {
      max-height: 249px;
    }
  }
  #carousel-5 {
    text-align: -webkit-center;
    img {
      max-height: 249px;
    }
  }

  @media (max-width: 1200px) {
    #carousel-2 {
      img {
        max-height: 198px;
      }
    }
    #carousel-3 {
      img {
        max-height: 194px;
      }
    }
    #carousel-4,
    #carousel-5 {
      img {
        max-height: 198px;
      }
    }
  }
  @media (max-width: 991px) {
    #carousel-2 {
      img {
        max-height: 325px;
      }
    }
    #carousel-3 {
      img {
        max-height: 325px;
      }
    }
  }
  @media (max-width: 767px) {
    #carousel-2 {
      img {
        max-height: 235px;
      }
    }
    #carousel-5 {
      img {
        max-height: 250px;
      }
    }
  }
}
</style>
